<template>
  <div>
    <a-card>
      <a-form-model :model="filterParams" v-bind="fiOptionsFilter" ref="filterForm">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colSpanFilter">
            <a-form-model-item :label="$t('Año')" prop="year" has-feedback
                               :rules="[{ required: true, message: 'Valor requerido' }]">
              <a-input v-model="filterParams.year">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colSpanFilter">
            <a-form-model-item :label="$t('Mes')" prop="month" has-feedback
                               :rules="[{ required: true, message: 'Valor requerido' }]">
              <a-select v-model="filterParams.month">
                <a-select-option v-for="mes in months_name" :key="mes.value">
                  {{ mes.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colSpanFilter">
            <a-form-model-item :wrapper-col="{ span: 16 }">
              <a-button type="primary" @click="filtrar">Filtrar</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <br><br>
    <g-master :name="master.endpoint"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :parentData="filterParams"
              @action="masterAction"
              :actions="master.actions"
              ref="master"
              modalWidth="70%"
              @params="paramsTable"
    >
      <span slot="estadoRenderer" slot-scope="{text}">
        <a-tag :color="text==='LIQ' ? 'blue' : (text === 'CER' ? 'red' : 'red')">{{text}}</a-tag>
      </span>
      <template slot="customButton">
        <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
      </template>
    </g-master>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="DETALLE MARCACION" key="2">
        <overtime-details v-if="id_emp" :id_emp="id_emp" :fecha_ini="fecha_ini_turno"></overtime-details>
        <span v-else>Dar clic en el icono <a-icon type="search"/> para ver el detalle las marcaciones.</span>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        registroSeleccionado: {},
        buttonExcelLoading: false,
        fileNameExcel: 'liq_turnos_cerrados',
        paramsT: {},
        endpointExcel: 'overtime_liq_/downloadExcel',
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        master: {
          endpoint: 'overtime_liq',
          actions: false,
          tableSetup: {
            customSlots: ['estadoRenderer'],
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            actions: {
              actions: [
                {
                  name: 'detalles',
                  text: 'Detalles',
                  icon: 'search',
                  props: {size: 'small', type: 'link', icon: 'search', style: 'color:green;'}
                }
              ]
            },
            columns: [
              {title: 'ID empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre del empleado', dataIndex: 'nombre_empleado', sorter: true},
              {
                title: 'Fecha Inicio del Turno',
                dataIndex: 'date_mark_ini',
                sorter: true,
                scopedSlots: {filterDropdown: 'dateBetweenFilter'}
              },
              {title: this.$t('Tipo Dia Ini.'), dataIndex: 'fecha_ini_es_festivo', sorter: true},
              {
                title: 'Fecha Fin del Turno',
                dataIndex: 'date_mark_end',
                sorter: true,
                scopedSlots: {filterDropdown: 'dateBetweenFilter'}
              },
              {title: this.$t('Tipo Dia Fin.'), dataIndex: 'fecha_fin_es_festivo', sorter: true},
              {title: 'Turno', dataIndex: 'tipo_marcacion', sorter: true},
              {title: 'Clase de Turno', dataIndex: 'mark_class', sorter: true},
              {title: 'Tipo de Turno', dataIndex: 'type_mark', sorter: true},
              {title: 'Grupo', dataIndex: 'grupo', sorter: true},
              {title: 'Puesto', dataIndex: 'puesto', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'month', sorter: true},
              {title: 'Periodo', dataIndex: 'period', sorter: true},
              {title: this.$t('Hora Ini. Marcacion'), dataIndex: 'start_time', sorter: true},
              {title: this.$t('Hora Fin Marcacion'), dataIndex: 'end_time', sorter: true},
              {title: this.$t('Horas Salario'), dataIndex: 'hours', sorter: true},
              {title: this.$t('Observaciones'), dataIndex: 'observations', sorter: true},
              {title: this.$t('Hrs. Extras Diurnas'), dataIndex: 'hours_ext_diur', sorter: true},
              {title: this.$t('Hrs. Extras Nocturna'), dataIndex: 'hours_ext_noct', sorter: true},
              {title: this.$t('Rec. Nocturno'), dataIndex: 'hours_rec_noct', sorter: true},
              {title: this.$t('Hrs. Extras Diurnas Festivas'), dataIndex: 'hours_ext_diur_fest', sorter: true},
              {title: this.$t('Hrs. Extras Nocturnas Festivas'), dataIndex: 'hours_ext_noct_fest', sorter: true},
              {title: this.$t('Rec. Diurno Dominical'), dataIndex: 'hours_rec_dominical', sorter: true},
              {title: this.$t('Rec. Nocturno Dominical'), dataIndex: 'hours_rec_dom_sin_comp', sorter: true},
              {title: this.$t('Rec. Diurno Festivo'), dataIndex: 'hours_rec_dom_sin_comp_fest', sorter: true},
              {title: this.$t('Rec. Nocturno Festivo'), dataIndex: 'hours_rec_noct_esp', sorter: true},
              {title: this.$t('Origen'), dataIndex: 'origen', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'status',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          }
        },
        filterParams: {
          filter_parent_overtime_liq_hist: true,
          year: parseInt(moment().format('YYYY')),
          month: parseInt(moment().format('MM')),
          company: null
        },
        fiOptionsFilter: {
          'label-col': {span: 6},
          'wrapper-col': {span: 16}
        },
        colSpanFilter: {
          xs: 8,
          md: 6
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'detalles':
            this.registroSeleccionado = action.record
            break
        }
      },
      paramsTable (params) {
        this.paramsT = params
      },
      filtrar () {
        if (!this.$isEmpty(this.filterParams.year) || !this.$isEmpty(this.filterParams.month)) {
          this.filterParams = {
            filter_parent_overtime_liq_hist: true,
            year: this.filterParams.year,
            month: this.filterParams.month
          }
        } else {
          this.filterParams = {}
        }
      }
    },
    computed: {
      parentData () {
        return this.filterParams
      },
      overtimeLiqInfo () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0] : null
      },
      paramsExcel () {
        return {...this.paramsT, ...this.parentData, columns: this.master.tableSetup.columns}
      },
      id_emp () {
        return this.registroSeleccionado.id_emp
      },
      fecha_ini_turno () {
        return this.registroSeleccionado.date_mark_ini
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/OvertimeTurn/OvertimeLiqCer.vue